import { buildPlaceUrls, contract, PlaceTypeKeyEnum, } from '@aviv_price-pages/brand';
import HttpClient from '@/adapters/http/HttpClient';
import { activePlaceTypes, level } from '@/entities/types/placeType';
import { findBestActiveDescendantId } from '@/utils/findBestDescendantId';
export function isPlaceInsideCity(placeTypeKey) {
    return level(placeTypeKey) > level(PlaceTypeKeyEnum.MUNICIPALITY);
}
export function getPlacesWithGeometry({ geoConfig }) {
    return Object.entries(geoConfig)
        .filter(([, { map }]) => map?.hasGeometry)
        .map(([placeType]) => placeType);
}
export function getActivePlaceTypes() {
    return activePlaceTypes(contract);
}
export async function getPlaceBestDescendantUrl(place) {
    const descendants = place.lineage?.descendants;
    if (descendants) {
        const bestActiveDescendantId = findBestActiveDescendantId(descendants);
        if (bestActiveDescendantId) {
            const httpClient = HttpClient.getInstance();
            const place = await httpClient.get(`${process.env.BFF_BASE_URL}/place?id=${bestActiveDescendantId}&locale=${contract.i18n.defaultLocale}`, undefined, process.env.BFF_API_KEY);
            return (await buildPlaceUrls(contract.nameAbbreviation, [place]))[0];
        }
    }
}
